// 问题类型映射
export const questionTypeMap = [
  [1, '导师服务'],
  [2, '预约相关'],
  [3, 'ZOOM使用'],
  [4, '平台使用'],
  [5, '产品相关'],
  [6, 'Other']
]
